import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Home, Search, Clock, ShoppingCart, User } from 'lucide-react';

export default function MobileLayout() {
  return (
    <div className="mobile-app flex flex-col" data-testid="mobile-layout">
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}

function BottomNav() {
  const { pathname } = useLocation();

  const tabs = [
    { to: '/home',              label: 'Início',    Icon: Home,         testid: 'nav-inicio' },
    { to: '/pedidos',           label: 'Novo Pedido', Icon: ShoppingCart, testid: 'nav-pedidos' },
    { to: '/pedidos/historico', label: 'Histórico', Icon: Clock,        testid: 'nav-historico' },
    { to: '/perfil',            label: 'Perfil',    Icon: User,         testid: 'nav-perfil' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border flex z-20 max-w-[430px] mx-auto"
      data-testid="mobile-bottom-nav"
    >
      {tabs.map(({ to, label, Icon, testid }) => {
        const isActive = pathname === to || (to !== '/home' && pathname.startsWith(to));
        return (
          <NavLink
            key={to}
            to={to}
            end={to === '/home'}
            className={`flex-1 flex flex-col items-center py-3 gap-0.5 text-[10px] font-body transition-colors ${
              isActive ? 'text-brand-primary' : 'text-brand-text-muted'
            }`}
            data-testid={testid}
          >
            <Icon className="w-5 h-5" strokeWidth={1.8} />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

